// import { usePermissionsContext } from 'store/permissions';
// import { PermissionKeys } from 'store/types';
import { FaPlus, FaRegFile, FaRegChartBar, FaRegCalendarAlt, FaUserClock, FaHammer, FaSuitcase } from 'react-icons/fa';
import { HiOutlineUserGroup } from 'react-icons/hi';

interface IProps {
  shouldSeeLeaves: boolean;
  shouldSeeHourlyAbsences: boolean;
  shouldSeeHealthAndSafetyTraining: boolean;
  shouldSeeWorkTrips: boolean;
}

export const getClientAdminMenuItems = ({
  shouldSeeLeaves,
  shouldSeeHourlyAbsences,
  shouldSeeHealthAndSafetyTraining,
  shouldSeeWorkTrips,
}: IProps) => {
  const menuItems = [
    {
      label: 'menu.createDocument',
      icon: FaPlus,
      to: '/documents-wizard/step-1',
      type: 'button',
    },
    {
      label: 'menu.documents',
      icon: FaRegFile,
      to: '/documents/received',
    },
    {
      label: 'menu.structure',
      icon: HiOutlineUserGroup,
      to: '/structure/groups',
    },
    {
      label: 'menu.reports',
      icon: FaRegChartBar,
      to: '/reports/documents',
    },
  ];

  if (shouldSeeLeaves) {
    menuItems.push({
      label: 'menu.leaves',
      icon: FaRegCalendarAlt,
      to: '/leaves',
    });
  }

  if (shouldSeeHourlyAbsences) {
    menuItems.push({
      label: 'menu.hourlyAbsences',
      icon: FaUserClock,
      to: '/hourly-absences',
    });
  }

  if (shouldSeeHealthAndSafetyTraining) {
    menuItems.push({
      label: 'menu.healthAndSafetyTraining',
      icon: FaHammer,
      to: '/health-and-safety-training',
    });
  }

  if (shouldSeeWorkTrips) {
    menuItems.push({
      label: 'menu.workTrips',
      icon: FaSuitcase,
      to: '/work-trips',
    });
  }

  return menuItems;
};

export default getClientAdminMenuItems;
